// Vietnamese translations.
export const vi = {
  // Navigation
  'nav.overview': 'Tổng quan',
  'nav.dashboard': 'Bảng điều khiển',
  'nav.analytics': 'Phân tích',
  'nav.reportingDashboard': 'Bảng báo cáo',
  'nav.sales': 'Bán hàng',
  'nav.salesOrders': 'Đơn bán hàng',
  'nav.purchase': 'Mua hàng',
  'nav.purchaseOrders': 'Đơn mua hàng',
  'nav.purchaseReview': 'Không gian xem xét',
  'nav.purchase.sprints': 'Sprint',
  'nav.supplierOnboarding': 'Tiếp nhận nhà cung cấp',
  'nav.po': 'PO',
  'nav.po.sprints': 'Sprint',
  'nav.po.newSprint': 'Tạo Sprint',
  'nav.scout': 'Scout',
  'nav.scout.wochenplanung': 'Kế hoạch tuần',
  'nav.scout.tagesplanung': 'Kế hoạch ngày',
  'nav.scout.prequal': 'Gọi PreQual',
  'nav.scout.missionen': 'Nhiệm vụ',
  'nav.scout.missionControl': 'Điều khiển nhiệm vụ',
  'nav.scout.unternehmenssuche': 'Tìm kiếm công ty',
  'nav.scout.preferences': 'Tùy chọn',
  'nav.scout.hilfe': 'Trợ giúp',
  'nav.scout.scorecard': 'Bảng điểm',
  'nav.poSprints': 'PO/Sprint',
  'nav.wiki': 'Wiki',
  'nav.supportVisualization': 'Hình ảnh hỗ trợ',
  'nav.navigationTiles': 'Ô điều hướng',
  'nav.styleGuide': 'Hướng dẫn phong cách',
  'nav.inventory': 'Kho',
  'nav.items': 'Mục',
  'nav.warehouse': 'Kho',
  'nav.picking': 'Lấy hàng',
  'nav.asn': 'ASN',
  'nav.returns': 'Trả hàng',
  'nav.accounting': 'Kế toán',
  'nav.accountsReceivable': 'Phải thu',
  'nav.crm': 'CRM',
  'nav.leads': 'Khách hàng tiềm năng',
  'nav.contacts': 'Liên hệ',
  'nav.ai': 'AI',
  'nav.commandCenter': 'Trung tâm điều khiển',
  'nav.workflows': 'Quy trình',
  'nav.workflowManagement': 'Quản lý quy trình',
  'nav.projectManagement': 'Quản lý dự án',
  'nav.support': 'Hỗ trợ',
  'nav.tickets': 'Phiếu',
  'nav.pivotTable': 'Bảng tổng hợp',
  'nav.learning': 'Học tập',
  'nav.curriculumPlanning': 'Kế hoạch chương trình',
  'nav.learnerDashboard': 'Bảng điều khiển người học',
  'nav.accessibleLearnerDashboard': 'Bảng điều khiển người học truy cập',
  'nav.settings': 'Cài đặt',
  'nav.general': 'Chung',
  'nav.company': 'Công ty',
  'nav.addressManagement': 'Quản lý địa chỉ',
  'nav.usersRoles': 'Người dùng và vai trò',
  'nav.auditLog': 'Nhật ký kiểm toán',
  'nav.integrations': 'Tích hợp',
  'nav.appOverview': 'Tổng quan ứng dụng',
  'nav.appOverviewDescription': 'Nhấp vào ứng dụng để điều hướng hoặc kéo ô để sắp xếp lại',
  'header.help': 'Trợ giúp',
  'header.account': 'Tài khoản',
  'header.portalName': 'Cổng CLANDA',
  'header.preferences': 'Tùy chọn',
  'header.language': 'Ngôn ngữ',

  // Help page

  // Privacy page

  // Form

  // Placeholders

  // Status

  // Actions
  'action.delete': 'Xóa',

  // Messages
  'message.success': 'Thành công',
  'message.error': 'Lỗi',

  // Common
  'common.yes': 'Có',
  'common.no': 'Không',
  'common.cancel': 'Hủy',
  'common.confirm': 'Xác nhận',
  'common.save': 'Lưu',
  'common.saving': 'Đang lưu…',
  'common.saveChanges': 'Lưu thay đổi',
  'common.close': 'Đóng',
  'common.reset': 'Đặt lại',
  'common.back': 'Quay lại',
  'common.loading': 'Đang tải...',
  'common.search': 'Tìm kiếm',
  'common.search.placeholder': 'Tìm kiếm...',
  'common.filter': 'Lọc',
  'common.sort': 'Sắp xếp',
  'common.add': 'Thêm',
  'common.delete': 'Xóa',
  'common.edit': 'Chỉnh sửa',
  'common.error': 'Lỗi',
  'common.remove': 'Xóa',
  'common.minutesShort': '{{value}} phút',
  'common.na': 'N/A',
  'common.days': 'ngày',
  'common.status.active': 'hoạt động',
  'common.status.paused': 'tạm dừng',
  'common.status.stopped': 'dừng',
  'common.status.pending': 'đang chờ',
  'common.status.completed': 'hoàn thành',
  'common.status.planned': 'Đã lên kế hoạch',
  'common.status.inProgress': 'Đang thực hiện',
  'common.status.done': 'Xong',
  'common.apply': 'Áp dụng',
  'common.actions.filter': 'Lọc',
  'common.actions.export': 'Xuất',
  'common.actions.search': 'Tìm kiếm',
  'common.dialog.defaultTitle': 'Hộp thoại',
  'common.all': 'Tất cả',
  'common.total': 'Tổng',
  'common.pending': 'Đang chờ',
  'common.assigned': 'Đã giao',
  'common.inProgress': 'Đang thực hiện',
  'common.completed': 'Hoàn thành',
  'common.cancelled': 'Đã hủy',
  'common.approved': 'Đã duyệt',
  'common.rejected': 'Từ chối',
  'common.processing': 'Đang xử lý',
  'common.overdue': 'Quá hạn',
  'common.partial': 'Một phần',
  'common.highPriority': 'Ưu tiên cao',
  'common.tableView': 'Xem bảng',
  'common.cardView': 'Xem thẻ',
  'common.switchToTable': 'Chuyển sang xem bảng',
  'common.switchToCard': 'Chuyển sang xem thẻ',
  'common.openMenu': 'Mở menu',
  'common.details': 'Chi tiết',
  'common.overview': 'Tổng quan',
  'common.new': 'Mới',
  'common.draft': 'Nháp',
  'common.shipped': 'Đã gửi',
  'common.delivered': 'Đã giao',
  'common.received': 'Đã nhận',
  'common.inTransit': 'Đang vận chuyển',
  'common.itemsPicked': 'Đã lấy hàng',
  'common.totalRefund': 'Tổng hoàn tiền',
  'common.totalPrice': 'Tổng giá',
  'common.orderSummary': 'Tóm tắt đơn hàng',
  'common.subtotal': 'Tạm tính:',
  'common.tax': 'Thuế:',
  'common.discount': 'Giảm giá:',
  'common.totalColon': 'Tổng:',

  // Date Range Filter (canonical component)
  'dateRange.today': 'Hôm nay',
  'dateRange.yesterday': 'Hôm qua',
  'dateRange.last7Days': '7 ngày qua',
  'dateRange.last14Days': '14 ngày qua',
  'dateRange.last30Days': '30 ngày qua',
  'dateRange.thisMonth': 'Tháng này',
  'dateRange.custom': 'Tùy chọn',

  // Dashboard
  'widget.vsLastPeriod': 'so với kỳ trước',
  'table.showing': 'Hiển thị',
  'table.of': 'của',
  'table.page': 'Trang',
  'table.previous': 'Trước',
  'table.next': 'Tiếp',
  'table.filterGroups': 'Nhóm bộ lọc',
  'table.addFilterGroup': 'Thêm nhóm bộ lọc',
  'table.filterGroup': 'Nhóm bộ lọc',
  'table.addCondition': 'Thêm điều kiện',
  'table.operator': 'Toán tử',
  'table.field': 'Trường',
  'table.noFilterGroups': 'Không có nhóm bộ lọc.',
  'filter.operator.equals': 'bằng',
  'filter.operator.not_equals': 'không bằng',
  'filter.operator.contains': 'chứa',
  'filter.operator.not_contains': 'không chứa',
  'filter.operator.starts_with': 'bắt đầu bằng',
  'filter.operator.ends_with': 'kết thúc bằng',
  'filter.operator.gt': 'lớn hơn',
  'filter.operator.lt': 'nhỏ hơn',
  'filter.operator.gte': 'ít nhất',
  'filter.operator.lte': 'nhiều nhất',
  'filter.operator.between': 'giữa',
  'filter.operator.in': 'là một trong',
  'filter.operator.not_in': 'không phải một trong',
  'filter.operator.is_set': 'đã đặt',
  'filter.operator.is_not_set': 'chưa đặt',
  'filter.placeholder.value': 'Giá trị',
  'filter.placeholder.min': 'Tối thiểu',
  'filter.placeholder.max': 'Tối đa',
  'filter.placeholder.select': 'Chọn…',
  'filter.placeholder.selectMultiple': 'Chọn giá trị…',
  'filter.logic.and': 'VÀ',
  'filter.logic.or': 'HOẶC',

  // Documents

  // Validation

  // Toasts

  // Reviewer Dashboard

  // Account / Settings
  'settings.title': 'Cài đặt tài khoản',

  // Consent
  'consent.title': 'Đồng ý',
  'consent.label': 'Tôi đồng ý với điều khoản và chính sách đặt hàng',
  'consent.description': 'Tôi đã đọc và chấp nhận điều khoản.',
  'consent.required': 'Vui lòng đồng ý với điều khoản.',
  'consent.link.terms': 'Điều khoản',

  // Contacts
  'contacts.title': 'Liên hệ',
  'contacts.role': 'Vai trò',
  'contacts.role.admin': 'Quản trị',
  'contacts.role.billing': 'Thanh toán',
  'contacts.role.technical': 'Kỹ thuật',
  'contacts.role.other': 'Khác',

  // ARIA / Accessibility

  // Auth
  'auth.callback.title': 'Xác thực',

  // Debug

  // Deliveries

  // SKU Mappings

  // PO List

  // PO Sprints

  // Terms page

  // Common UI Elements

  // Dashboard

  // AI Command Center

  // Learning & Development
  'learning.feed.greeting': 'Xin chào {{name}}!',
  'learning.feed.levelInfo': 'Cấp {{level}} • {{xp}} XP',
  'learning.feed.offline': 'Ngoại tuyến',
  'learning.feed.streakLabel': 'Chuỗi ngày',
  'learning.feed.dailyGoal': 'Mục tiêu hàng ngày',
  'learning.feed.recommendedLessons': 'Bài học gợi ý',
  'learning.feed.priority.high': 'Cao',
  'learning.feed.priority.medium': 'Trung bình',
  'learning.feed.priority.low': 'Thấp',
  'learning.feed.difficulty.easy': 'Dễ',
  'learning.feed.difficulty.medium': 'Trung bình',
  'learning.feed.difficulty.hard': 'Khó',
  'learning.feed.aiRecommendation': 'Đề xuất AI',
  'learning.feed.actions.start': 'Bắt đầu',
  'learning.feed.actions.skip': 'Bỏ qua',
  'learning.feed.actions.reload': 'Tải lại',
  'learning.feed.empty.title': 'Đã hoàn thành tất cả bài!',

  // Helpdesk / Tickets
  'learning.feed.empty.description': 'Bạn đã hoàn thành tất cả bài có sẵn hôm nay. Quay lại vào ngày mai!',
  'learning.quiz.title': 'Quiz',
  'learning.quiz.questionCounter': 'Câu {{current}} / {{total}}',
  'learning.quiz.options.true': 'Đúng',
  'learning.quiz.options.false': 'Sai',
  'learning.quiz.actions.next': 'Tiếp',
  'learning.quiz.actions.finish': 'Kết thúc',
  'learning.quiz.actions.retry': 'Thử lại',
  'learning.quiz.badge.xp': '{{xp}} XP',
  'learning.quiz.badge.time': '{{seconds}}s',
  'learning.quiz.result.passedTitle': 'Đã qua quiz!',
  'learning.quiz.result.failedTitle': 'Chưa qua quiz',
  'learning.quiz.result.scoreSummary': '{{correct}} / {{total}} đúng',
  'learning.quiz.result.xpEarned': 'Nhận +{{xp}} XP',
  'learning.quiz.result.answersHeading': 'Chi tiết câu trả lời',
  'learning.quiz.result.questionLabel': 'Câu {{index}}',
  'learning.quiz.result.yourAnswer': 'Câu trả lời của bạn',
  'learning.quiz.result.correctAnswer': 'Đáp án đúng',
  'learning.lessonCard.difficulty.easy': 'Dễ',
  'learning.lessonCard.difficulty.medium': 'Trung bình',
  'learning.lessonCard.difficulty.hard': 'Khó',
  'learning.lessonCard.status.completed': 'Hoàn thành',
  'learning.lessonCard.reward': 'Phần thưởng',
  'learning.lessonCard.progress': 'Tiến độ',
  'learning.lessonCard.selectFormat': 'Chọn định dạng',
  'learning.lessonCard.prerequisites': 'Điều kiện tiên quyết',
  'learning.lessonCard.actions.start': 'Bắt đầu',
  'learning.lessonCard.actions.repeat': 'Lặp lại',
  'learning.lessonCard.actions.pause': 'Tạm dừng',
  'learning.lessonCard.actions.complete': 'Hoàn thành',
  'learning.lessonCard.actions.bookmark': 'Đánh dấu',
  'learning.lessonCard.actions.unbookmark': 'Bỏ đánh dấu',
  'learning.lessonCard.actions.collapse': 'Thu gọn',
  'learning.lessonCard.actions.expand': 'Mở rộng',
  'learning.lessonCard.goalLabel': 'Mục tiêu',
  'learning.lessonCard.formats.video': 'Xem video',
  'learning.lessonCard.formats.text': 'Đọc văn bản',
  'learning.lessonCard.formats.audio': 'Nghe audio',
  'learning.lessonCard.formats.cheatSheet': 'Tóm tắt',
  'learning.lessonCard.formatUnknown': 'Không xác định',
  'learning.accessible.title': 'Bảng điều khiển học tập',
  'learning.accessible.welcome': 'Chào mừng trở lại, {{name}}',
  'learning.accessible.voice.start': 'Giọng nói',
  'learning.accessible.voice.stop': 'Dừng nghe',
  'learning.accessible.voice.listening': 'Đang nghe...',
  'learning.accessible.level': 'Cấp',
  'learning.accessible.xpToNext': '{{value}} XP tới cấp tiếp theo',
  'learning.accessible.streak': 'Chuỗi',
  'learning.accessible.days': '{{value}} ngày',
  'learning.accessible.keepItUp': 'Tiếp tục!',
  'learning.accessible.badges': 'Huy hiệu',
  'learning.accessible.achievementsEarned': 'Thành tựu',
  'learning.accessible.tabs.overview': 'Tổng quan',
  'learning.accessible.tabs.lessons': 'Bài học',
  'learning.accessible.tabs.progress': 'Tiến độ',
  'learning.accessible.tabs.achievements': 'Thành tựu',
  'learning.accessible.recentActivity': 'Hoạt động gần đây',
  'learning.accessible.noRecentActivity': 'Không có hoạt động',
  'learning.accessible.start': 'Bắt đầu',
  'learning.accessible.learningProgress': 'Tiến độ học',
  'learning.accessible.overallProgress': 'Tiến độ tổng thể',
  'learning.accessible.achievements': 'Thành tựu',
  'learning.accessible.startingLesson': 'Bắt đầu bài {{id}}',
  'learning.accessible.difficulty.beginner': 'Mới bắt đầu',
  'learning.accessible.difficulty.intermediate': 'Trung cấp',
  'learning.accessible.difficulty.advanced': 'Nâng cao',

  // Gamification & XP Toast
  'gamification.xpToast.xpLabel': 'XP',
  'gamification.xpToast.streakProgress': 'Tiến độ chuỗi',
  'gamification.xpToast.streakProgressValue': '{{current}} / {{target}}',
  'gamification.xpToast.source.lesson': 'Bài học',
  'gamification.xpToast.source.quiz': 'Quiz',
  'gamification.xpToast.source.streak': 'Chuỗi',
  'gamification.xpToast.source.badge': 'Huy hiệu',
  'gamification.xpToast.source.bonus': 'Thưởng',
  'gamification.xpToast.levelUp.title': 'Lên cấp!',
  'gamification.xpToast.levelUp.description': 'Bạn đã đạt cấp {{level}}!',
  'gamification.xpToast.levelUp.xpEarned': 'Nhận +{{xp}} XP',
  'gamification.xpToast.button.continue': 'Tiếp tục',
  'gamification.xpToast.streakMilestone.title': 'Mốc chuỗi!',
  'gamification.xpToast.streakMilestone.description': 'Đạt chuỗi {{count}} ngày!',
  'gamification.xpToast.streakMilestone.bonus': 'Nhận +{{xp}} XP thưởng',
  'gamification.close': 'Đóng',

  // Knowledge Base
  'knowledgeBase.back': 'Quay lại',
  'knowledgeBase.article.view': 'Xem',
  'knowledgeBase.article.views': '{{count}} lượt xem',
  'knowledgeBase.article.helpful': '{{count}} hữu ích',
  'knowledgeBase.article.notHelpful': '{{count}} không hữu ích',
  'knowledgeBase.article.byAuthor': 'Bởi {{author}}',
  'knowledgeBase.header.title': 'Cơ sở kiến thức',
  'knowledgeBase.header.subtitle': 'Tìm câu trả lời cho câu hỏi của bạn',
  'knowledgeBase.actions.filter': 'Lọc',
  'knowledgeBase.actions.sort': 'Sắp xếp',
  'knowledgeBase.search.placeholder': 'Tìm trong cơ sở kiến thức...',
  'knowledgeBase.tabs.all': 'Tất cả',
  'knowledgeBase.stats.popular': 'Bài viết phổ biến nhất',
  'knowledgeBase.stats.viewsCount': '{{count}} lượt xem',
  'knowledgeBase.stats.helpful': 'Bài viết hữu ích nhất',
  'knowledgeBase.stats.ratingsCount': '{{count}} đánh giá',
  'knowledgeBase.stats.total': 'Tổng bài viết',
  'knowledgeBase.stats.totalCount': '{{count}} bài viết',
  'knowledgeBase.empty.title': 'Không tìm thấy bài viết',
  'knowledgeBase.empty.searching': 'Thử từ khóa khác hoặc xem danh mục.',
  'knowledgeBase.empty.default': 'Chưa có bài viết trong danh mục này.',
  'knowledgeBase.difficulty.beginner': 'Mới bắt đầu',
  'knowledgeBase.difficulty.intermediate': 'Trung cấp',
  'knowledgeBase.difficulty.advanced': 'Chuyên gia',
  'knowledgeBase.categories.odoo-basics': 'Cơ bản Odoo',
  'knowledgeBase.categories.crm': 'CRM & Bán hàng',
  'knowledgeBase.categories.inventory': 'Kho & Mua hàng',
  'knowledgeBase.categories.accounting': 'Kế toán',
  'knowledgeBase.categories.projects': 'Quản lý dự án',
  'knowledgeBase.categories.troubleshooting': 'Xử lý sự cố',

  // Accounting

  // Curriculum Planning
  'curriculum.video': 'Video',
  'curriculum.videoDescription': 'Ghi màn hình hoặc video thực hành',
  'curriculum.cheatSheet': 'Tóm tắt',
  'curriculum.cheatSheetDescription': 'In được, mã QR',
  'curriculum.test': 'Bài kiểm tra/Quiz',
  'curriculum.testDescription': 'Khảo sát Odoo, 10 câu, 80%',
  'curriculum.checklist': 'Danh sách kiểm tra',
  'curriculum.checklistDescription': 'Tác vụ Odoo, có thể nhấp',
  'curriculum.textLesson': 'Văn bản/Bài học',
  'curriculum.textLessonDescription': 'Bài học khóa Odoo',
  'curriculum.roleplay': 'Đóng vai',
  'curriculum.roleplayDescription': 'Trực tiếp với người hướng dẫn',
  'curriculum.practice': 'Bài tập thực hành',
  'curriculum.practiceDescription': 'Thực hiện với khách hàng',

  // UI Components
  // Common Actions

  // Purchase Onboarding (wizard)

  // SCOUT - Weekly planning
  'scout.wochenplanung.title': 'Tổng quan tuần',
  'scout.wochenplanung.previousWeek': 'Tuần trước',
  'scout.wochenplanung.nextWeek': 'Tuần sau',
  'scout.wochenplanung.toast.appointmentAdded': 'Đã thêm lịch hẹn',
  'scout.wochenplanung.toast.appointmentAddedDesc': '{{title}} – {{day}}',
  'scout.wochenplanung.toast.appointmentUpdated': 'Đã cập nhật lịch hẹn',
  'scout.wochenplanung.toast.appointmentUpdatedDesc': '{{title}} – {{day}}',
  'scout.wochenplanung.toast.appointmentDeleted': 'Đã xóa lịch hẹn',
  'scout.wochenplanung.toast.slotUpdated': 'Đã cập nhật slot',
  'scout.wochenplanung.toast.slotUpdatedDesc': 'Đã giải quyết nhiệm vụ hoặc xóa slot.',
  'scout.wochenplanung.legend.completed': 'hoàn thành',
  'scout.wochenplanung.legend.planned': 'đã lên kế hoạch',
  'scout.wochenplanung.legend.partial': 'lên kế hoạch một phần',
  'scout.wochenplanung.legend.unplanned': 'chưa lên kế hoạch',
  'scout.wochenplanung.legend.holiday': 'Ngày lễ / Nghỉ',
  'scout.wochenplanung.dialog.deleteAppointment.title': 'Xóa lịch hẹn',
  'scout.wochenplanung.dialog.deleteAppointment.description': 'Bạn có chắc muốn xóa lịch hẹn này? Không thể hoàn tác.',
  'scout.wochenplanung.dialog.editAppointment.title': 'Chỉnh sửa lịch hẹn',
  'scout.wochenplanung.dialog.editAppointment.description': 'Bạn có muốn áp dụng thay đổi cho lịch hẹn này?',
  'scout.wochenplanung.employee': 'Nhân viên',
  'scout.wochenplanung.selectEmployee': 'Chọn nhân viên',
  'scout.wochenplanung.allEmployees': 'Tất cả nhân viên',
  'scout.wochenplanung.error.loading': 'Lỗi tải kế hoạch tuần',
  'scout.wochenplanung.error.retry': 'Thử lại',

  // SCOUT - Mission list
  'scout.missions.industries.placeholder': 'Chọn ngành',
  'scout.missions.industries.search': 'Tìm ngành...',
  'scout.missions.industries.empty': 'Không tìm thấy ngành',
  'scout.missions.products.placeholder': 'Chọn dòng sản phẩm',
  'scout.missions.products.search': 'Tìm dòng sản phẩm...',
  'scout.missions.products.empty': 'Không tìm thấy dòng sản phẩm',
  'scout.missionControl.tabs.team': 'Tổng quan đội',
  'scout.missionControl.teamMembers': 'Thành viên đội',
  'scout.missionControl.table.employee': 'Nhân viên',
  'scout.missionControl.table.team': 'Đội',
  'scout.missionControl.table.plzAreas': 'Khu vực mã bưu điện',

  // SCOUT - Mission Preferences

  // SCOUT - Missions
  'scout.missionen.bestandskunden.loadError': 'Lỗi tải khách hàng hiện có',
  'scout.missionen.bestandskunden.empty': 'Không tìm thấy khách hàng hiện có',
  'scout.missionen.bestandskunden.search': 'Tìm kiếm khách hàng hiện có...',
  'scout.missionen.bestandskunden.filteredCount': '{{filtered}} trong {{total}} khách hàng hiện có',
  'scout.missionen.wunschliste.industriesTitle': 'Ngành ưu tiên',
  'scout.missionen.wunschliste.productsTitle': 'Sản phẩm ưu tiên',
  'scout.missionen.wunschliste.plzTitle': 'Khu vực mã bưu điện ưu tiên',
  'scout.missionen.wunschliste.saveButton': 'Lưu',
  'scout.missionen.wunschliste.saved': 'Đã lưu',
  'scout.missionen.wunschliste.savedDesc': 'Tùy chọn của bạn đã được lưu.',
  'scout.missionen.wunschliste.saveError': 'Lỗi',
  'scout.missionen.wunschliste.saveErrorDesc': 'Không thể lưu tùy chọn.',
  'scout.missionen.wunschliste.loadError': 'Lỗi tải tùy chọn',
  'scout.tagesplanung.title': 'Kế hoạch ngày',
  'scout.tagesplanung.addressUnknown': 'Không rõ địa chỉ',
  'scout.tagesplanung.routeMapLabel': 'Bản đồ tuyến',
  'scout.tagesplanung.routePlanning': 'Lên tuyến đường',
  'scout.tagesplanung.traffic': 'Giao thông',
  'scout.tagesplanung.deferNotPossible': 'Không thể hoãn',
  'scout.tagesplanung.deferMaxReached': 'Đã đạt số lần hoãn tối đa hôm nay (3/3).',
  'scout.tagesplanung.deferAlreadyDeferred': 'Lead này đã được hoãn hôm nay.',
  'scout.tagesplanung.dayCannotClose': 'Không thể đóng ngày',
  'scout.tagesplanung.outstandingReports': 'Còn {{count}} báo cáo ghé thăm chưa hoàn thành. Vui lòng điền hết trước khi đóng ngày.',
  'scout.tagesplanung.andMore': '... và {{count}} nữa',
  'scout.tagesplanung.tabs.planning': 'Kế hoạch ngày',
  'scout.tagesplanung.tasks.tabLabel': 'Nhiệm vụ',
  'scout.tagesplanung.tasks.empty': 'Không có nhiệm vụ',
  'scout.tagesplanung.tasks.loading': 'Đang tải nhiệm vụ',
  'scout.tagesplanung.tasks.error': 'Không thể tải nhiệm vụ',
  'scout.tagesplanung.tasks.filterFieldStatus': 'Trạng thái',
  'scout.tagesplanung.tasks.filterStatusTodo': 'Cần làm',
  'scout.tagesplanung.tasks.filterStatusInProgress': 'Đang làm',
  'scout.tagesplanung.tasks.filterStatusDone': 'Hoàn thành',
  'scout.tagesplanung.tasks.priorityLabel': 'Ưu tiên',
  'scout.tagesplanung.tasks.priorityValue': '{{value}}',
  'scout.tagesplanung.tasks.priorityUnknown': '—',
  'scout.tagesplanung.tasks.dueLabel': 'Hạn',
  'scout.tagesplanung.tasks.dueNone': 'Không có hạn',
  'scout.lead.neukunde': 'Khách hàng mới — sản phẩm thích hợp làm mở cửa',
  'scout.lead.bestandskunde': 'Khách hàng hiện có',
  'scout.metrics.besuche': 'Ghé thăm',
  'scout.metrics.demos': 'Demo',
  'scout.metrics.auftraege': 'Đơn hàng',
  'scout.metrics.umsatz': 'Doanh thu',
  'scout.metrics.demoRate': 'Tỷ lệ demo',
  'scout.composition.title': 'Thành phần nhiệm vụ',
  'scout.composition.minBestandskunden': 'Tối thiểu khách hiện có',
  'scout.composition.minQualifiziert': 'Tối thiểu lead đủ điều kiện',
  'scout.composition.maxKaltbesuche': 'Tối đa ghé lạnh',

  // Scout daily planning
  'scout.dailyPlanning.addAppointment': 'Thêm lịch hẹn',
  'scout.dailyPlanning.appointments': 'Lịch hẹn',
  'scout.dailyPlanning.noAppointmentsPlanned': 'Không có lịch hẹn cho ngày này',
  'scout.dailyPlanning.leadsByPriority': 'Lead (theo ưu tiên)',
  'scout.dailyPlanning.noLeadsPlanned': 'Không có lead cho ngày này',
  'scout.dailyPlanning.skipLead': 'Bỏ qua lead',
  'scout.dailyPlanning.skipLeadConfirmation': 'Bạn có chắc muốn bỏ qua lead này? Sẽ chuyển sang ngày tiếp theo.',
  'scout.dailyPlanning.skip': 'Bỏ qua',
  'scout.dailyPlanning.removeLead': 'Xóa lead',
  'scout.dailyPlanning.removeLeadConfirmation': 'Bạn có chắc muốn xóa lead này? Sẽ bị loại khỏi vòng quay.',
  'scout.dailyPlanning.selectMissionToViewLeads': 'Chọn nhiệm vụ để xem lead',
  'scout.dailyPlanning.selectDate': 'Chọn ngày',
  'scout.dailyPlanning.nextDay': 'Ngày tiếp theo',
  'scout.dailyPlanning.closeDay': 'Đóng ngày',
  'scout.dailyPlanning.reopenDay': 'Mở lại ngày',
  'scout.dailyPlanning.noAcceptedLeads': 'Không có lead được chấp nhận cho ngày này.',
  'scout.dailyPlanning.statusSkipped': 'Đã bỏ qua',
  'scout.dailyPlanning.selectAll': 'Chọn tất cả',
  'scout.dailyPlanning.selectAllLeads': 'Chọn tất cả lead',
  'scout.dailyPlanning.noSuggestions': 'Không có gợi ý.',
  'scout.dailyPlanning.previousDay': 'Ngày trước',
  'scout.dailyPlanning.calendarWeek': 'Tuần {{weekNumber}}',
  'scout.dailyPlanning.visit': 'Ghé thăm',
  'scout.dailyPlanning.details': 'Chi tiết',
  'scout.dailyPlanning.missionsLoading': 'Đang tải nhiệm vụ…',
  'scout.dailyPlanning.leadsLoading': 'Đang tải lead…',
  'scout.dailyPlanning.noLeadsFound': 'Không tìm thấy lead',
  'scout.dailyPlanning.moreLeads': 'thêm',
  'scout.dailyPlanning.dailyList': 'Danh sách ngày',
  'scout.dailyPlanning.unknown': 'Không xác định',
  'scout.dailyPlanning.suggestedLeads': 'Lead gợi ý',
  'scout.dailyPlanning.error': 'Lỗi: {{error}}',
  'scout.dailyPlanning.help': 'Trợ giúp',
  'scout.dailyPlanning.bulkActions': 'Thao tác hàng loạt',
  'scout.dailyPlanning.actionsCount': 'Thao tác ({{count}})',
  'scout.dailyPlanning.accept': 'Chấp nhận',
  'scout.dailyPlanning.reject': 'Từ chối',
  'scout.dailyPlanning.selectLead': 'Chọn lead {{name}}',
  'scout.dailyPlanning.openLeadDetails': 'Mở chi tiết {{name}}',
  'scout.dailyPlanning.score': 'Điểm: {{score}}',
  'scout.dailyPlanning.loading': 'Đang tải kế hoạch ngày',

  // Scout weekly planning

  // Scout scorecard
  'scout.scorecard.selectHeatmapMetric': 'Chọn chỉ số heatmap',
  'scout.scorecard.orders': 'Đơn hàng',
  'scout.scorecard.annualTargetOrders': 'Mục tiêu đơn hàng năm',
  'scout.scorecard.comingSoon': 'Sắp có',
  'scout.scorecard.kpiOverview': 'Tổng quan KPI, hoạt động và ngành hàng đầu',
  'scout.scorecard.activityByDay': 'Hoạt động theo ngày',
  'scout.scorecard.title': 'Bảng điểm',
  'scout.scorecard.period.tag': 'Ngày',
  'scout.scorecard.period.woche': 'Tuần',
  'scout.scorecard.period.monat': 'Tháng',
  'scout.scorecard.period.jahr': 'Năm',
  'scout.scorecard.kpiTilesHeading': 'Ô KPI',
  'scout.scorecard.topBranchenProdukteHeading': 'Ngành hàng đầu và sản phẩm hàng đầu',
  'scout.scorecard.soll': 'Mục tiêu',
  'scout.scorecard.forecast': 'Dự báo',
  'scout.scorecard.gapToGo': 'Khoảng còn lại',
  'scout.scorecard.csvExport': 'Xuất CSV',
  'scout.scorecard.pdfExport': 'Xuất PDF',
  'scout.scorecard.table.date': 'Ngày',
  'scout.scorecard.table.visits': 'Ghé thăm',
  'scout.scorecard.table.demos': 'Demo',
  'scout.scorecard.table.orders': 'Đơn hàng',
  'scout.scorecard.table.60l': '60L',
  'scout.scorecard.table.25l': '25L',
  'scout.scorecard.table.10l': '10L',
  'scout.scorecard.table.netRevenue': 'Doanh thu ròng',
  'scout.scorecard.table.total': 'Tổng',
  'scout.scorecard.topBranchen': 'Ngành hàng đầu',
  'scout.scorecard.topProdukte': 'Sản phẩm hàng đầu',
  'scout.scorecard.table.industry': 'Ngành',
  'scout.scorecard.table.quantity': 'Số lượng (đơn vị)',
  'scout.scorecard.table.revenue': 'Doanh thu (€)',
  'scout.scorecard.table.product': 'Sản phẩm',
  'scout.scorecard.table.salesVolume': 'Khối lượng bán',
  'scout.scorecard.table.customers': 'Khách hàng',
  'scout.scorecard.kpi.visits': 'Ghé thăm',
  'scout.scorecard.kpi.demos': 'Demo',
  'scout.scorecard.kpi.orders': 'Đơn hàng',
  'scout.scorecard.kpi.netRevenue': 'Doanh thu ròng',
  'scout.scorecard.kpi.gebinde60l': 'Đơn vị 60L',
  'scout.scorecard.kpi.gebinde25l': 'Đơn vị 25L',
  'scout.scorecard.kpi.gebinde10l': 'Đơn vị 10L',
  'scout.scorecard.emptyTitle': 'Không có dữ liệu',
  'scout.scorecard.emptyDescription': 'Không có dữ liệu KPI cho khoảng thời gian đã chọn.',
  'scout.scorecard.missionPerformanceTitle': 'Hiệu suất nhiệm vụ',
  'scout.scorecard.missionMissionsCompleted': 'Nhiệm vụ hoàn thành',
  'scout.scorecard.missionConversionRate': 'Tỷ lệ chuyển đổi',
  'scout.scorecard.missionTerritoryCoverage': 'Phủ khu vực',
  'scout.scorecard.viewMissionDetails': 'Xem chi tiết',
  'scout.scorecard.adjustTargets': 'Điều chỉnh mục tiêu',
  'scout.scorecard.annualTarget': 'Mục tiêu năm',
  'scout.scorecard.annualTargetVisits': 'Mục tiêu ghé thăm năm',
  'scout.scorecard.annualTargetDemos': 'Mục tiêu demo năm',
  'scout.scorecard.annualTargetNetRevenue': 'Doanh thu ròng (€)',
  'scout.scorecard.annualTargetNetRevenueA11y': 'Mục tiêu doanh thu ròng năm bằng EUR',
  'scout.scorecard.monthlyOverrides': 'Ghi đè hàng tháng',
  'scout.scorecard.table.month': 'Tháng',
  'scout.scorecard.table.reason': 'Lý do',
  'scout.scorecard.derivedTargets': 'Mục tiêu dẫn xuất',
  'scout.scorecard.dailyTargetLabel': 'Mục tiêu ngày: {{count}} ghé thăm',
  'scout.scorecard.weeklyTargetLabel': 'Mục tiêu tuần: {{count}} ghé thăm',
  'scout.scorecard.save': 'Lưu',
  'scout.scorecard.heatmap.visits': 'Ghé thăm',
  'scout.scorecard.heatmap.demos': 'Demo',
  'scout.scorecard.heatmap.revenue': 'Doanh thu',
  'scout.scorecard.heatmap.low': 'Thấp',
  'scout.scorecard.heatmap.high': 'Cao',
  'scout.scorecard.heatmap.scaleA11y': 'Thang màu từ thấp đến cao',
  'scout.scorecard.heatmap.loading': 'Đang tải bản đồ…',

  // Inventory

  // Sales

  // Purchase


  // Scout mission control
  'scout.missionControl.teamOverview': 'Đội của bạn và khu vực mã bưu điện',
  'scout.missionControl.jokerLimitPerDay': 'Giới hạn joker / ngày',
  'scout.missionControl.jokerLimitUpdated': 'Đã cập nhật giới hạn joker.',
  'scout.missionControl.jokerLimitSaveFailed': 'Không thể lưu giới hạn joker.',
  'scout.missionControl.selectTeam': 'Chọn đội',
  'scout.missionControl.none': 'Không',
  'scout.missionControl.addPlzAreaFor': 'Thêm khu vực mã bưu điện cho',
  'scout.missionControl.addPlzArea': 'Thêm khu vực mã bưu điện',
  'scout.missionControl.noTeamMembersFound': 'Không tìm thấy thành viên đội.',
  'scout.missionControl.orders': 'Đơn hàng',
  'scout.missionControl.resetSettings': 'Đặt lại cài đặt',
  'scout.missionControl.saveSettings': 'Lưu cài đặt',
  'scout.missionControl.territorySaturation': 'Bão hòa khu vực (mã bưu điện)',
  'scout.missionControl.day': 'Ngày',
  'scout.missionControl.selectDay': 'Chọn ngày',
  'scout.missionControl.week': 'Tuần',
  'scout.missionControl.selectWeek': 'Chọn tuần',
  'scout.missionControl.month': 'Tháng',
  'scout.missionControl.selectMonth': 'Chọn tháng',
  'scout.missionControl.planFulfillment': 'Thực hiện kế hoạch',
  'scout.missionControl.plzPrefixPlaceholder': 'Tiền tố mã bưu điện (vd. 70)',
  'scout.missionControl.plzPrefix': 'Tiền tố mã bưu điện',
  'scout.missionControl.addPlzToWhitelist': 'Thêm tiền tố vào danh sách trắng',
  'scout.missionControl.addPlzToGreylist': 'Thêm tiền tố vào danh sách xám',
  'scout.missionControl.addPlzToYellowlist': 'Thêm tiền tố vào danh sách vàng',
  'scout.missionControl.addNewTeamMember': 'Thêm thành viên đội mới',
  'scout.missionControl.lastModified': 'Sửa lần cuối',
  'scout.missionControl.outsideAreaRules': 'Quy tắc ngoài khu vực',
  'scout.missionControl.outsidePlzPolicy': 'Chính sách mã bưu điện ngoài danh sách',
  'scout.missionControl.enableOutsideWarning': 'Bật cảnh báo mã bưu điện ngoài khu vực',
  'scout.missionControl.requireOutsideApproval': 'Yêu cầu duyệt cho mã bưu điện ngoài khu vực',
  'scout.missionControl.rejectOutsidePlz': 'Từ chối mã bưu điện ngoài khu vực',
  'scout.missionControl.checkPlz': 'Kiểm tra mã bưu điện hoặc tiền tố',
  'scout.missionControl.check': 'Kiểm tra',
  'scout.missionControl.error': 'Lỗi',
  'scout.missionControl.success': 'Thành công',
  'scout.missionControl.userProfileNotFound': 'Không tìm thấy hồ sơ người dùng',
  'scout.missionControl.plzAreasUpdated': 'Đã cập nhật khu vực mã bưu điện',
  'scout.missionControl.plzAreasSaveFailed': 'Không thể lưu khu vực mã bưu điện',
  'scout.missionControl.repConfig.title': 'Cấu hình đại diện',
  'scout.missionControl.repConfig.repName': 'Tên / Email',
  'scout.missionControl.repConfig.industries': 'Ngành',
  'scout.missionControl.repConfig.products': 'Sản phẩm',
  'scout.missionControl.repConfig.plz': 'Mã bưu điện',
  'scout.missionControl.repConfig.loadError': 'Không thể tải cấu hình đại diện',
  'scout.missionControl.repConfig.saveError': 'Lưu thất bại',
  'scout.missionControl.repConfig.savedTitle': 'Đã lưu',
  'scout.missionControl.repConfig.savedDesc': 'Đã cập nhật cấu hình đại diện',
  'scout.missionControl.jokerConfig.title': 'Giới hạn joker mỗi ngày',
  'scout.missionControl.jokerConfig.description': 'Số lần dùng joker tối đa mỗi đại diện mỗi ngày.',
  'scout.missionControl.jokerConfig.maxPerDay': 'Tối đa mỗi ngày',
  'scout.missionControl.jokerConfig.loadError': 'Không thể tải cấu hình joker',
  'scout.missionControl.jokerConfig.saveError': 'Lưu thất bại',
  'scout.missionControl.jokerConfig.savedTitle': 'Đã lưu',
  'scout.missionControl.jokerConfig.savedDesc': 'Đã cập nhật giới hạn joker',
  'scout.missionControl.diagnostics.demoRate': 'Tỷ lệ demo',
  'scout.missionControl.diagnostics.visitDepth': 'Độ sâu ghé thăm',
  'scout.unternehmenssuche.selectAllResults': 'Chọn tất cả kết quả tìm kiếm',
  'scout.unternehmenssuche.openingHours': 'GIỜ MỞ CỬA',
  'scout.unternehmenssuche.temporarilyClosed': 'Tạm đóng cửa',
  'scout.unternehmenssuche.startSearch': 'Bắt đầu tìm',
  'scout.search.selectStatus': 'Chọn trạng thái...',
  'scout.unternehmenssuche.searchRunning': 'Đang tìm...',
  'scout.unternehmenssuche.adjustSearchCriteria': 'Vui lòng thay đổi tiêu chí tìm kiếm hoặc thử lại.',
  'scout.unternehmenssuche.selectCompanyType': 'Chọn loại công ty',
  'scout.unternehmenssuche.openingHoursTime': 'Giờ mở cửa',
  'scout.unternehmenssuche.noTimeNeeded': 'Không cần chỉ ra giờ',
  'scout.unternehmenssuche.addConditions': 'Thêm điều kiện để thu hẹp tìm kiếm',
  'scout.unternehmenssuche.addCondition': 'Thêm điều kiện',
  'scout.unternehmenssuche.addGroup': 'Thêm nhóm',
  'scout.unternehmenssuche.savedSearchName': 'Tên tìm kiếm đã lưu',
  'scout.unternehmenssuche.saveCurrentSearch': 'Lưu tìm kiếm hiện tại',
  'scout.unternehmenssuche.savedSearches': 'Tìm kiếm đã lưu',
  'scout.unternehmenssuche.noSavedSearches': 'Không có tìm kiếm đã lưu.',
  'scout.unternehmenssuche.keywordPlaceholder': 'vd. Nhà hàng, Quán bar, Tiệm bánh',
  'scout.unternehmenssuche.addWaypoint': 'Thêm điểm dừng',
  'scout.unternehmenssuche.locationPlaceholder': 'vd. Munich Marienplatz',
  'scout.unternehmenssuche.toggleAdditionalFilters': 'Hiện hoặc ẩn bộ lọc thêm',
  'scout.unternehmenssuche.additionalFilters': 'Bộ lọc thêm',
  'scout.unternehmenssuche.saveSearchAsFile': 'Lưu tìm kiếm thành tệp',
  'scout.unternehmenssuche.loadSearchFromFile': 'Tải tìm kiếm từ tệp',
  'scout.unternehmenssuche.checkSearchTerms': 'Vui lòng kiểm tra từ khóa hoặc thử lại.',
  'search.overlay.hint': 'Gõ và nhấn Enter hoặc nhấp Tìm kiếm.',
  'search.overlay.placeholder': 'Tìm (/) tài nguyên, tài liệu và thêm',
  'search.overlay.searchLabel': 'Tìm kiếm',
  'search.overlay.noResults': 'Không có kết quả cho "{{query}}"',
  'search.overlay.tryDifferent': 'Thử từ khóa khác hoặc kiểm tra chính tả.',
  'search.overlay.topResults': 'Kết quả hàng đầu',
  'search.overlay.documentation': 'Tài liệu · ',
  'scout.unternehmenssuche.locationRadius': 'Địa điểm + Bán kính',
  'scout.unternehmenssuche.routeCorridor': 'Tuyến + Hành lang',
  'scout.unternehmenssuche.withoutLocation': 'Không có địa điểm',
  'scout.scorecard.heatmapTitle': 'Heatmap hoạt động (mã bưu điện-2)',
  'scout.preferences.defaultRegionLabel': 'Khu vực mặc định',
  'scout.preferences.selectRegionPlaceholder': 'Chọn khu vực',
  'scout.preferences.defaultStatusLabel': 'Trạng thái mặc định',
  'scout.preferences.selectDefaultStatus': 'Chọn trạng thái mặc định',
  'scout.preferences.statusDraft': 'Nháp',
  'scout.preferences.statusActive': 'Hoạt động',
  'scout.preferences.statusCompleted': 'Hoàn thành',
  'scout.preferences.statusArchived': 'Lưu trữ',
  'scout.preferences.saving': 'Đang lưu...',
  'scout.preferences.plzPrefixes': 'Tiền tố mã bưu điện cho nhiệm vụ',
  'scout.preferences.plzPrefixesPlaceholder': 'Nhập tiền tố cách nhau bằng dấu phẩy (vd. 70, 71, 72)',
  'scout.preferences.maxRouteLength': 'Độ dài tuyến tối đa (km)',
  'scout.preferences.maxRouteLengthDescription': 'Độ dài tuyến tối đa tính bằng km',
  'scout.preferences.autoGenerateMissions': 'Tự tạo nhiệm vụ (tự động ban đêm)',
  'scout.preferences.autoGenerateDescription': 'Khi bật, nhiệm vụ sẽ được tạo tự động theo cài đặt của bạn.',
  'scout.preferences.defaultAssigneeLabel': 'Người phụ trách mặc định',
  'scout.preferences.defaultAssigneePlaceholder': 'Nhập người phụ trách mặc định',
  'scout.preferences.defaultAssigneeAria': 'Người phụ trách mặc định',
  'scout.preferences.defaultLeadCountLabel': 'Số lead mặc định',
  'scout.preferences.defaultLeadCountAria': 'Số lead mặc định',
  'scout.preferences.defaultDurationLabel': 'Thời lượng mặc định (ngày)',
  'scout.preferences.defaultDurationAria': 'Thời lượng mặc định tính bằng ngày',
  'scout.preferences.autoAssignLabel': 'Tự giao nhiệm vụ cho người phụ trách mặc định',
  'scout.preferences.productFamiliesLabel': 'Dòng sản phẩm',
  'scout.preferences.industryCodesLabel': 'Ngành',
  'scout.preferences.keywordsLabel': 'Từ khóa',
  'scout.preferences.keywordsPlaceholder': 'vd. bê tông, vữa',
  'scout.preferences.minLeadsLabel': 'Tối thiểu lead mỗi nhiệm vụ',
  'scout.preferences.minLeadsAria': 'Tối thiểu lead mỗi nhiệm vụ',
  'scout.preferences.maxLeadsLabel': 'Tối đa lead mỗi nhiệm vụ',
  'scout.preferences.maxLeadsAria': 'Tối đa lead mỗi nhiệm vụ',
  'scout.preferences.dailyQuotaLabel': 'Số nhiệm vụ mỗi ngày',
  'scout.preferences.dailyQuotaAria': 'Tối đa nhiệm vụ mỗi ngày',
  'scout.preferences.dailyQuotaHelper': 'Số nhiệm vụ tự tạo tối đa mỗi ngày (1-3)',
  'scout.dailyPlanning.inField': 'Ngoài hiện trường',
  'scout.dailyPlanning.completed': 'Hoàn thành',
  'scout.dailyPlanning.openDay': 'Mở ngày',
  'scout.dailyPlanning.dayMarkedCompleted': 'Ngày này đã được đánh dấu hoàn thành.',
  'scout.dailyPlanning.statusVisited': 'Đã ghé thăm',
  'scout.dailyPlanning.statusPlanned': 'Đã lên kế hoạch',
  'scout.dailyPlanning.statusCompleted': 'Hoàn thành',
  'scout.dailyPlanning.jokerAdd': 'Dùng joker',
  'scout.dailyPlanning.jokerTitle': 'Điểm dừng Joker',
  'scout.dailyPlanning.jokerUsed': 'đã dùng',
  'scout.dailyPlanning.jokerLimitReached': 'Đã đạt giới hạn joker trong ngày.',
  'scout.dailyPlanning.jokerCompany': 'Công ty',
  'scout.dailyPlanning.jokerCompanyPlaceholder': 'Nhập tên công ty',
  'scout.dailyPlanning.jokerReason': 'Lý do',
  'scout.dailyPlanning.jokerReasonPlaceholder': 'Tại sao cần điểm dừng này?',
  'scout.dailyPlanning.jokerCancel': 'Hủy',
  'scout.dailyPlanning.jokerSubmit': 'Dùng joker',
  'scout.dailyPlanning.jokerCreateError': 'Không thể tạo điểm dừng joker.',
  'scout.createMission.title': 'Tạo nhiệm vụ mới',
  'scout.createMission.description': 'Chọn tên, bộ lọc và giao',
  'scout.createMission.nameLabel': 'Tên',
  'scout.createMission.nameRequired': 'Bắt buộc nhập tên',
  'scout.createMission.namePlaceholder': 'vd. Stuttgart Bắc — Lạnh',
  'scout.createMission.nameAria': 'Tên nhiệm vụ',
  'scout.createMission.regionLabel': 'Khu vực (tùy chọn)',
  'scout.createMission.regionPlaceholder': 'vd. Mã bưu điện 70xxx',
  'scout.createMission.regionAria': 'Khu vực hoặc mã bưu điện',
  'scout.createMission.ownerLabel': 'Chủ sở hữu',
  'scout.createMission.ownerPlaceholder': 'Địa chỉ email',
  'scout.createMission.ownerAria': 'Email chủ sở hữu',
  'scout.createMission.themeLabel': 'Chủ đề (tùy chọn)',
  'scout.createMission.themePlaceholder': 'vd. Lạnh',
  'scout.createMission.themeAria': 'Chủ đề nhiệm vụ',
  'scout.createMission.productLabel': 'Sản phẩm (tùy chọn)',
  'scout.createMission.productPlaceholder': 'vd. K-2000',
  'scout.createMission.productAria': 'Sản phẩm',
  'scout.createMission.cancel': 'Hủy',
  'scout.createMission.save': 'Lưu',
  'scout.createMission.saveBusy': 'Đang lưu…',
  'scout.createMission.cancelAria': 'Hủy tạo nhiệm vụ',
  'scout.createMission.saveAria': 'Lưu nhiệm vụ',
  'scout.createMission.saveBusyAria': 'Đang lưu nhiệm vụ',

  // Settings
  'settings.description': 'Quản lý tùy chọn ứng dụng và tùy chỉnh',
  'settings.typography.title': 'Kiểu chữ',
  'settings.typography.description': 'Điều chỉnh cỡ chữ và mật độ để dễ đọc hoặc gọn hơn',
  'settings.typography.scale.title': 'Cỡ chữ',
  'settings.typography.scale.description': 'Chuẩn khớp cơ sở Masterslight; Thoải mái tăng cỡ cho phiên dài',
  'settings.typography.scale.ariaLabel': 'Preset cỡ chữ',
  'settings.typography.scale.compact': 'Gọn',
  'settings.typography.scale.standard': 'Chuẩn',
  'settings.typography.scale.comfort': 'Thoải mái',
  'settings.tabs.appearance': 'Giao diện',
  'settings.tabs.account': 'Tài khoản',
  'settings.tabs.notifications': 'Thông báo',
  'settings.tabs.security': 'Bảo mật',
  'settings.language.title': 'Tùy chọn ngôn ngữ',
  'settings.language.description': 'Chọn ngôn ngữ giao diện ứng dụng',
  'settings.language.interfaceLanguage': 'Ngôn ngữ giao diện',
  'settings.language.interfaceLanguageDesc': 'Chọn ngôn ngữ cho menu, nút và thành phần giao diện',
  'settings.theme.title': 'Giao diện màu',
  'settings.theme.description': 'Tùy chỉnh giao diện và màu',
  'settings.theme.predefinedThemes': 'Muốn chọn từ 10 giao diện có sẵn?',
  'settings.theme.goToThemeSettings': 'Đến Cài đặt giao diện',
  'settings.themeSettings.title': 'Cài đặt giao diện',
  'settings.themeSettings.description': 'Tùy chỉnh giao diện ứng dụng bằng giao diện có sẵn',
  'settings.themeSettings.themeDetails': 'Chi tiết giao diện',
  'settings.themeSettings.themeId': 'ID giao diện:',
  'settings.themeSettings.colorScheme': 'Bảng màu:',
  'settings.account.profile.title': 'Thông tin hồ sơ',
  'settings.account.profile.description': 'Cập nhật thông tin cá nhân và tài khoản',
  'settings.account.profile.name': 'Tên',
  'settings.account.profile.email': 'Email',
  'settings.account.profile.role': 'Vai trò',
  'settings.account.profile.department': 'Phòng ban',
  'settings.account.profile.editProfile': 'Chỉnh sửa hồ sơ',
  'settings.account.data.title': 'Quản lý dữ liệu',
  'settings.account.data.description': 'Quản lý đồng bộ và sao lưu dữ liệu',
  'settings.account.data.cloudSync': 'Đồng bộ đám mây',
  'settings.account.data.cloudSyncEnabled': 'Tùy chọn của bạn được đồng bộ lên đám mây',
  'settings.account.data.cloudSyncDisabled': 'Đồng bộ đám mây tắt (cờ tính năng)',
  'settings.account.data.syncNow': 'Đồng bộ ngay',
  'settings.notifications.title': 'Tùy chọn thông báo',
  'settings.notifications.description': 'Cấu hình cách nhận thông báo',
  'settings.notifications.email.title': 'Thông báo email',
  'settings.notifications.email.description': 'Nhận thông báo qua email',
  'settings.notifications.push.title': 'Thông báo đẩy',
  'settings.notifications.push.description': 'Nhận thông báo đẩy trên trình duyệt',
  'settings.notifications.system.title': 'Cảnh báo hệ thống',
  'settings.notifications.system.description': 'Thông báo hệ thống quan trọng',
  'settings.notifications.configure': 'Cấu hình',
  'settings.security.title': 'Cài đặt bảo mật',
  'settings.security.description': 'Quản lý bảo mật tài khoản và quyền riêng tư',
  'settings.security.password.title': 'Mật khẩu',
  'settings.security.password.lastChanged': 'Đổi lần cuối cách đây 30 ngày',
  'settings.security.password.change': 'Đổi',
  'settings.security.twoFactor.title': 'Xác thực hai yếu tố',
  'settings.security.twoFactor.description': 'Thêm lớp bảo mật',
  'settings.security.twoFactor.enable': 'Bật',
  'settings.security.sessions.title': 'Quản lý phiên',
  'settings.security.sessions.description': 'Quản lý phiên đang hoạt động',
  'settings.security.sessions.view': 'Xem phiên',
  'settings.company.title': 'Cài đặt công ty',
  'settings.company.description': 'Quản lý thông tin và tùy chọn công ty',
  'settings.company.edit': 'Chỉnh sửa công ty',
  'settings.company.saveChanges': 'Lưu thay đổi',
  'settings.company.cancel': 'Hủy',
  'settings.company.tabs.general': 'Chung',
  'settings.company.tabs.contact': 'Liên hệ',
  'settings.company.tabs.billing': 'Thanh toán',
  'settings.company.tabs.branding': 'Nhận diện thương hiệu',
  'settings.company.general.companyInfo': 'Thông tin công ty',
  'settings.company.general.companyName': 'Tên công ty',
  'settings.company.general.legalName': 'Tên pháp lý',
  'settings.company.general.taxId': 'Mã số thuế',
  'settings.company.general.registrationNumber': 'Số đăng ký',
  'settings.company.general.industry': 'Ngành',
  'settings.company.general.foundedYear': 'Năm thành lập',
  'settings.company.general.employees': 'Số nhân viên',
  'settings.company.general.industry.technology': 'Công nghệ',
  'settings.company.general.industry.manufacturing': 'Sản xuất',
  'settings.company.general.industry.retail': 'Bán lẻ',
  'settings.company.general.industry.healthcare': 'Y tế',
  'settings.company.general.industry.finance': 'Tài chính',
  'settings.company.general.industry.other': 'Khác',
  'settings.company.address.title': 'Thông tin địa chỉ',
  'settings.company.address.street': 'Địa chỉ đường',
  'settings.company.address.city': 'Thành phố',
  'settings.company.address.state': 'Tỉnh/Thành',
  'settings.company.address.zipCode': 'Mã bưu điện',
  'settings.company.address.country': 'Quốc gia',
  'settings.company.address.country.us': 'Hoa Kỳ',
  'settings.company.address.country.ca': 'Canada',
  'settings.company.address.country.uk': 'Vương quốc Anh',
  'settings.company.address.country.de': 'Đức',
  'settings.company.address.country.fr': 'Pháp',
  'settings.company.address.country.other': 'Khác',
  'settings.company.contact.title': 'Thông tin liên hệ',
  'settings.company.contact.phone': 'Số điện thoại',
  'settings.company.contact.email': 'Địa chỉ email',
  'settings.company.contact.website': 'Trang web',
  'settings.company.contact.supportEmail': 'Email hỗ trợ',
  'settings.company.billing.title': 'Cài đặt thanh toán',
  'settings.company.billing.currency': 'Tiền tệ',
  'settings.company.billing.taxRate': 'Thuế suất (%)',
  'settings.company.billing.paymentTerms': 'Điều khoản thanh toán',
  'settings.company.billing.billingCycle': 'Chu kỳ thanh toán',
  'settings.company.billing.paymentTerms.net15': 'Net 15',
  'settings.company.billing.paymentTerms.net30': 'Net 30',
  'settings.company.billing.paymentTerms.net45': 'Net 45',
  'settings.company.billing.paymentTerms.net60': 'Net 60',
  'settings.company.billing.paymentTerms.dueOnReceipt': 'Đến hạn khi nhận',
  'settings.company.billing.cycle.monthly': 'Hàng tháng',
  'settings.company.billing.cycle.quarterly': 'Hàng quý',
  'settings.company.billing.cycle.annually': 'Hàng năm',
  'settings.company.billing.cycle.custom': 'Tùy chỉnh',
  'settings.company.billing.summary.title': 'Tóm tắt thanh toán',
  'settings.company.billing.summary.currentPlan': 'Gói hiện tại',
  'settings.company.billing.summary.monthlyCost': 'Chi phí hàng tháng',
  'settings.company.billing.summary.nextBillingDate': 'Ngày thanh toán tiếp theo',
  'settings.company.billing.summary.paymentMethod': 'Phương thức thanh toán',
  'settings.company.billing.summary.status': 'Trạng thái',
  'settings.company.billing.summary.active': 'Hoạt động',
  'settings.company.branding.title': 'Nhận diện và giao diện thương hiệu',
  'settings.company.branding.logo': 'Logo công ty',
  'settings.company.branding.uploadLogo': 'Tải logo lên',
  'settings.company.branding.logoHint': 'PNG, JPG tối đa 2MB',
  'settings.company.branding.favicon': 'Favicon',
  'settings.company.branding.uploadFavicon': 'Tải favicon lên',
  'settings.company.branding.faviconHint': 'ICO, PNG tối đa 1MB',
  'settings.company.branding.primaryColor': 'Màu chính',
  'settings.company.branding.secondaryColor': 'Màu phụ',
  'settings.usersRoles.stats.totalUsers': 'Tổng người dùng',
  'settings.usersRoles.stats.activeUsers': 'người dùng hoạt động',
  'settings.usersRoles.stats.totalRoles': 'Tổng vai trò',
  'settings.usersRoles.stats.roleConfigurations': 'cấu hình vai trò',
  'settings.userManagement.title': 'Quản lý người dùng',
  'settings.userManagement.description': 'Quản lý người dùng, vai trò và cài đặt hệ thống',
  'settings.userManagement.addUser': 'Thêm người dùng',
  'settings.userManagement.editUser': 'Chỉnh sửa người dùng',
  'settings.userManagement.createNewUser': 'Tạo người dùng mới',
  'settings.userManagement.updateUserInfo': 'Cập nhật thông tin người dùng',
  'settings.userManagement.addNewUser': 'Thêm người dùng mới vào hệ thống',
  'settings.userManagement.tabs.users': 'Người dùng',
  'settings.userManagement.tabs.appAccess': 'Truy cập ứng dụng',
  'settings.userManagement.tabs.roles': 'Vai trò',
  'settings.userManagement.toast.userCreated': 'Đã tạo người dùng thành công',
  'settings.userManagement.toast.userUpdated': 'Đã cập nhật người dùng thành công',
  'settings.userManagement.toast.userDeleted': 'Đã xóa người dùng thành công',
  'settings.userManagement.toast.roleCreated': 'Đã tạo vai trò thành công',
  'settings.userManagement.toast.roleUpdated': 'Đã cập nhật vai trò thành công',
  'settings.userManagement.toast.roleDeleted': 'Đã xóa vai trò thành công',
  'settings.userManagement.toast.error': 'Tạo người dùng thất bại',
  'settings.userManagement.toast.errorUpdate': 'Cập nhật người dùng thất bại',
  'settings.userManagement.toast.errorDelete': 'Xóa người dùng thất bại',
  'settings.userManagement.toast.errorRoleCreate': 'Tạo vai trò thất bại',
  'settings.userManagement.toast.errorRoleUpdate': 'Cập nhật vai trò thất bại',
  'settings.userManagement.toast.errorRoleDelete': 'Xóa vai trò thất bại',
  'settings.integrations.settings.security.enabled': 'Đã bật',
  'settings.integrations.settings.security.disabled': 'Đã tắt',

  // Analytics - Pivot Table

  // Reports

  // Warehouse - Picking

  // Warehouse - Returns

  // Warehouse - ASN

  // CRM - Contacts
  'crm.contacts.title': 'Liên hệ CRM',
  'crm.contacts.description': 'Quản lý liên hệ khách hàng và nhà cung cấp kèm địa chỉ',
  'crm.contacts.add': 'Thêm liên hệ',
  'crm.contacts.edit': 'Chỉnh sửa liên hệ',
  'crm.contacts.delete': 'Xóa liên hệ',
  'crm.contacts.view360': 'Xem 360°',
  'crm.contacts.unassigned': 'Chưa giao',
  'crm.contacts.type.customer': 'Khách hàng',
  'crm.contacts.type.supplier': 'Nhà cung cấp',
  'crm.contacts.type.partner': 'Đối tác',
  'crm.contacts.type.prospect': 'Triển vọng',
  'crm.contacts.status.active': 'Hoạt động',
  'crm.contacts.status.inactive': 'Không hoạt động',
  'crm.contacts.status.suspended': 'Đình chỉ',
  'crm.contacts.validation.companyRequired': 'Bắt buộc nhập tên công ty',
  'crm.contacts.validation.streetRequired': 'Bắt buộc nhập địa chỉ đường',
  'crm.contacts.validation.postalRequired': 'Bắt buộc nhập mã bưu điện',
  'crm.contacts.validation.cityRequired': 'Bắt buộc nhập thành phố',
  'crm.contacts.validation.countryRequired': 'Bắt buộc nhập quốc gia',
  'crm.contacts.validation.nameRequired': 'Bắt buộc nhập tên liên hệ',
  'crm.contacts.validation.emailInvalid': 'Địa chỉ email không hợp lệ',
  'crm.contacts.validation.phoneRequired': 'Bắt buộc nhập số điện thoại',
  'crm.contacts.validation.salesPersonRequired': 'Bắt buộc nhân viên bán hàng',
  'crm.contacts.validation.ordererNameRequired': 'Bắt buộc tên người đặt',
  'crm.contacts.validation.roleRequired': 'Bắt buộc vai trò',
  'crm.contacts.validation.hoursRequired': 'Bắt buộc giờ',
  'crm.openMenu': 'Mở menu',

  // CRM - Leads
  'crm.leads.title': 'Lead',
  'crm.leads.description': 'Quản lý lead bán hàng và theo dõi chuyển đổi',
  'crm.leads.add': 'Thêm lead',
  'crm.leads.edit': 'Chỉnh sửa lead',
  'crm.leads.delete': 'Xóa lead',
  'crm.leads.status.new': 'Mới',
  'crm.leads.status.contacted': 'Đã liên hệ',
  'crm.leads.status.qualified': 'Đủ điều kiện',
  'crm.leads.status.proposal': 'Đề xuất',
  'crm.leads.status.negotiation': 'Đàm phán',
  'crm.leads.status.closedWon': 'Thắng',
  'crm.leads.status.closedLost': 'Thua',
  'crm.leads.source.website': 'Trang web',
  'crm.leads.source.referral': 'Giới thiệu',
  'crm.leads.source.email': 'Email',
  'crm.leads.source.phone': 'Điện thoại',
  'crm.leads.source.social': 'Mạng xã hội',
  'crm.leads.source.other': 'Khác',
  'crm.leads.value': 'Giá trị',
  'crm.leads.lastContact': 'Liên hệ cuối',
  'crm.leads.notes': 'Ghi chú',
  'crm.leads.search': 'Tìm lead...',
  'crm.leads.filterByStatus': 'Lọc theo trạng thái',
  'crm.leads.filterBySource': 'Lọc theo nguồn',
  'crm.leads.totalLeads': 'Tổng lead',
  'crm.leads.pipelineValue': 'Giá trị pipeline',
  'crm.leads.qualifiedLeads': 'Lead đủ điều kiện',

  // Common (extra)
  'common.next': 'Tiếp',

  // Scout Wochenplanung — Aggregates

  // Scout Mission Control — Plan View

  // CRM — Leads page (flat keys)
  'crm.leads': 'Lead',
  'crm.closedWon': 'Giao dịch thắng',
  'crm.searchPlaceholder': 'Tìm lead...',
  'crm.name': 'Tên',
  'crm.company': 'Công ty',
  'crm.contact': 'Liên hệ',
  'crm.source': 'Nguồn',
  'crm.value': 'Giá trị',
  'crm.lastContact': 'Liên hệ cuối',
  'crm.viewDetails': 'Xem chi tiết',
  'crm.editLead': 'Chỉnh sửa lead',
  'crm.addNote': 'Thêm ghi chú',
  'crm.convertToCustomer': 'Chuyển thành khách hàng',
  'crm.deleteLead': 'Xóa lead',
  'crm.leadDetails': 'Chi tiết lead',
  'crm.addNewLead': 'Thêm lead mới',
  'crm.viewLeadDetails': 'Xem chi tiết lead',
  'crm.createNewLead': 'Tạo lead mới',
  'crm.fullName': 'Họ tên',
  'crm.email': 'Email',
  'crm.phone': 'Điện thoại',
  'crm.estimatedValue': 'Giá trị ước tính',
  'crm.notes': 'Ghi chú',
  'crm.status.new': 'Mới',
  'crm.status.contacted': 'Đã liên hệ',
  'crm.status.qualified': 'Đủ điều kiện',
  'crm.status.proposal': 'Đề xuất',
  'crm.status.negotiation': 'Đàm phán',
  'crm.status.closedWon': 'Thắng',
  'crm.status.closedLost': 'Thua',
  'crm.source.website': 'Trang web',
  'crm.source.referral': 'Giới thiệu',
  'crm.source.tradeShow': 'Hội chợ',
  'crm.source.coldCall': 'Gọi lạnh',
  'crm.source.socialMedia': 'Mạng xã hội',
  'crm.source.emailCampaign': 'Chiến dịch email',

  // Supplier onboarding — Form
  'country.US': 'Hoa Kỳ',
  'country.CA': 'Canada',
  'country.MX': 'Mexico',
  'country.GB': 'Vương quốc Anh',
  'country.DE': 'Đức',
  'country.FR': 'Pháp',
  'country.other': 'Khác',

  // Purchase (list/detail)

  // Sales (list)

  // PO Sprints (page titles)

  // Navigation (App Overview)
  'navigation.appOverview': 'Tổng quan ứng dụng',

  // Learning — Lehrplan & Curriculum
  'learning.lehrplan.title': 'Chương trình giảng dạy',
  'learning.lehrplan.subtitle': 'Quản lý chương trình và mục tiêu học tập',
  'learning.curriculumPlanning.title': 'Kế hoạch chương trình',
  'learning.curriculumPlanning.subtitle': 'Cấu trúc chương trình và gán nội dung học',

  // Visit Report
  'visitReport.title': 'Báo cáo ghé thăm',
  'visitReport.createTitle': 'Tạo báo cáo ghé thăm',
  'visitReport.titleFor': 'Báo cáo ghé thăm cho {{name}}',
  'visitReport.visitType': 'Loại ghé thăm',
  'visitReport.coldVisit': 'Ghé lạnh',
  'visitReport.appointment': 'Lịch hẹn',
  'visitReport.salesOutcome': 'Kết quả bán hàng',
  'visitReport.noContact': 'Không liên hệ được',
  'visitReport.conversation': 'Trò chuyện',
  'visitReport.demo': 'Demo',
  'visitReport.order': 'Đơn hàng',
  'visitReport.orderValue': 'Giá trị đơn (EUR)',
  'visitReport.nextStep': 'Bước tiếp theo',
  'visitReport.callback': 'Gọi lại',
  'visitReport.sendOffer': 'Gửi báo giá',
  'visitReport.revisit': 'Ghé lại',
  'visitReport.completed': 'Hoàn thành',
  'visitReport.appointmentWindow': 'Khung lịch hẹn (tùy chọn)',
  'visitReport.from': 'Từ',
  'visitReport.to': 'Đến',
  'visitReport.contactName': 'Tên người liên hệ',
  'visitReport.enterName': 'Nhập tên',
  'visitReport.roleFunction': 'Vai trò / Chức năng',
  'visitReport.enterRole': 'Nhập chức năng',
  'visitReport.isDecisionMaker': 'Là người quyết định?',
  'visitReport.decisionMakerName': 'Tên người quyết định',
  'visitReport.decisionMakerRole': 'Chức năng người quyết định',
  'visitReport.email': 'Email (tùy chọn)',
  'visitReport.phone': 'Điện thoại (tùy chọn)',
  'visitReport.notes': 'Ghi chú (tùy chọn)',
  'visitReport.additionalInfo': 'Thông tin bổ sung...',
  'visitReport.productsDiscussed': 'Đã thảo luận sản phẩm?',
  'visitReport.annualDemand': 'Nhu cầu hàng năm',
  'visitReport.select': 'Chọn',
  'visitReport.interest': 'Quan tâm',
  'visitReport.interestHigh': 'cao',
  'visitReport.interestMedium': 'trung bình',
  'visitReport.interestLow': 'thấp',
  'visitReport.modelFeedback': 'Đề xuất hệ thống có phù hợp không?',
  'visitReport.feedbackYes': 'Có',
  'visitReport.feedbackPartially': 'Một phần',
  'visitReport.feedbackNo': 'Không',
  'visitReport.feedbackNotSeen': 'Chưa xem',
  'visitReport.branchCorrect': 'Ngành đúng không? (tùy chọn)',
  'visitReport.selectBranch': 'Chọn ngành',
  'visitReport.branchConstruction': 'Xây dựng',
  'visitReport.branchIndustry': 'Công nghiệp',
  'visitReport.branchTrade': 'Thương mại',
  'visitReport.branchService': 'Dịch vụ',
  'visitReport.noInterestReason': 'Lý do không quan tâm',
  'visitReport.wrongProduct': 'Sai sản phẩm',
  'visitReport.wrongTiming': 'Sai thời điểm',
  'visitReport.existingSupplier': 'Đã có nhà cung cấp',
  'visitReport.noBudget': 'Không có ngân sách',
  'visitReport.noNeed': 'Không có nhu cầu',
  'visitReport.decisionMakerNotReached': 'Không gặp được người quyết định',
  'visitReport.additionalRemarks': 'Nhận xét thêm (tùy chọn)',
  'visitReport.error': 'Lỗi',
  'visitReport.validationError': 'Vui lòng chọn loại ghé thăm và kết quả bán hàng.',
  'visitReport.deferralNotPossible': 'Không thể hoãn',
  'visitReport.maxDeferralReached': 'Bạn đã hoãn báo cáo cuối. Vui lòng hoàn thành.',
  'visitReport.reportDeferred': 'Đã hoãn báo cáo',
  'visitReport.deferralMessage': 'Bạn có thể điền báo cáo sau.',
  'visitReport.reportCreated': 'Đã tạo báo cáo ghé thăm',
  'visitReport.reportSaved': 'Đã lưu báo cáo ghé thăm.',
  'visitReport.reportSavedFor': 'Đã lưu báo cáo ghé thăm cho {{name}}.',
  'visitReport.reportError': 'Không thể tạo báo cáo ghé thăm.',
  'visitReport.stepOf': 'Bước {{current}} / {{total}}',
  'visitReport.back': 'Quay lại',
  'visitReport.cancel': 'Hủy',
  'visitReport.inAHurry': 'Tôi đang vội',
  'visitReport.next': 'Tiếp',
  'visitReport.saving': 'Đang lưu...',
  'visitReport.finishVisit': 'Kết thúc ghé thăm',
  'visitReport.contactNotes': 'Thông tin thêm về người liên hệ...',
  'visitReport.callingQueue.prompt': 'Có chuẩn bị cuộc gọi hẹn AI cho lead này không?',
  'visitReport.callingQueue.yes': 'Có, thêm vào hàng đợi',
  'visitReport.callingQueue.no': 'Không',
  'visitReport.callingQueue.toast': 'Đã thêm lead vào hàng đợi gọi.',

  // Visit Report — Rejection (B1)

  // Visit Report — Post-Visit (B2)

  // Visit Report — Compliance Gate (B3)
  'scout.visitReport.compliance.title': 'Báo cáo ghé thăm chưa hoàn thành',
  'scout.visitReport.compliance.description': 'Bạn còn {{count}} báo cáo ghé thăm chưa điền. Vui lòng hoàn thành trước.',
  'scout.visitReport.compliance.lockoutTitle': 'Cần báo cáo',
  'scout.visitReport.compliance.lockoutDescription': 'Vui lòng hoàn thành tất cả báo cáo ghé thăm mở trước khi tiếp tục.',
  'scout.visitReport.compliance.deferButton': 'Điền sau',
  'scout.visitReport.compliance.deferCount': 'Còn {{remaining}} lần hoãn',
  'scout.visitReport.compliance.noDeferrals': 'Không còn lần hoãn',
  'scout.visitReport.compliance.fillReport': 'Điền báo cáo',
  'scout.visitReport.compliance.morningLockout': 'Kế hoạch ngày bị khóa đến khi điền hết báo cáo mở.',

  // Admin (SS-145)
  'app.routes.loadingSettings': 'Đang tải cài đặt...',
  'companySearch.filters.companySize': 'Quy mô công ty',
  'curriculum.modules.pillar': 'Trụ',
  'curriculum.modules.selectLevel': 'Chọn cấp độ',
  'curriculum.modules.selectPillar': 'Chọn trụ',
  'curriculum.modules.selectPillarOption': 'Chọn trụ',
  'learning.lessonViewer.audioNotSupported': 'Trình duyệt không hỗ trợ audio.',
  'learning.lessonViewer.complete': 'Hoàn thành',
  'learning.lessonViewer.formatNotSupported': 'Không hỗ trợ định dạng',
  'learning.lessonViewer.videoNotSupported': 'Trình duyệt không hỗ trợ video.',
  'learning.moduleEditor.pillar': 'Trụ',
  'learning.moduleEditor.pillarLabel': 'Trụ',
  'learning.tabs.availableLessons': 'Bài học có sẵn',
  'learning.tabs.availableQuizzes': 'Quiz có sẵn',
  'missions.management.decisionMakerMet': 'Đã gặp người quyết định',
  'missions.management.wonAmount': 'Doanh thu thắng',
  'missions.management.demoPerformed': 'Đã thực hiện demo',
  'missions.management.demoPerformedLabel': 'Đã thực hiện demo',
  'missions.management.kpiDescription': 'Gặp người quyết định, demo, doanh thu',
  'missions.management.moreActions': 'Xem thêm thao tác cho nhiệm vụ',
  'missions.management.publish': 'Xuất bản',
  'missions.management.searchPlaceholder': 'Tìm (Tên/Khu vực/Chủ đề/Sản phẩm)',
  'mobile.layout.closeMenu': 'Đóng menu',
  'mobile.layout.menu': 'Menu',
  'mobile.layout.noOfflineContent': 'Không có nội dung ngoại tuyến',
  'mobile.layout.offlinePerformance': 'Để hoạt động ngoại tuyến tốt hơn',
  'navigation.tileCard.openActions': 'Mở thao tác ô',
  'scout.preferences.badenWuerttemberg': 'Baden-Württemberg',
  'scout.preferences.thueringen': 'Thüringen',
  'scout.sprints.ciEstimate': 'Ước tính thời gian chạy CI',
  'scout.sprints.estimatedMinutes': 'Phút ước tính',
  'styleGuide.charts.noStatusColors': 'Biểu đồ không được dùng màu trạng thái',
  'styleGuide.confirmation': 'Xác nhận',
  'styleGuide.description': 'Mô tả',
  'styleGuide.statusSemantics.success': 'Thành công = Hoàn thành / OK',
  'tickets.list.filterPriority': 'Lọc theo ưu tiên',
  'ui.calendar.nextMonth': 'Tháng sau',
  'ui.errorBoundary.returnToDashboard': 'Quay lại bảng điều khiển',
  'ui.impersonation.selectImpersonation': 'Chọn mạo danh',
  'ui.impersonation.selectUser': 'Chọn người dùng:',
  'ui.routingPreview.openAppleMaps': 'Mở trong Apple Maps',
  'ui.routingPreview.openGoogleMaps': 'Mở trong Google Maps',
  'ui.routingPreview.stopsLabel': '{{count}} điểm dừng · {{distance}} km · {{time}} phút (ước tính)',
  'ui.routingPreview.title': 'Xem trước tuyến đường',
  'weeklyPlanning.appointmentModal.additionalNotes': 'Ghi chú thêm',
  'weeklyPlanning.legacyAppointments.addAppointment': 'Thêm lịch hẹn',
  'scout.help.selectArticle': 'Chọn bài bên trái hoặc dùng tìm kiếm để mở bài trợ giúp.',

  // Modals (SS-145)
  'modals.assignMissionModal.close': 'Đóng',
  'modals.assignMissionModal.searchPlaceholder': 'Tìm (Tiêu đề/Ngành)',
  'modals.assignMissionModal.searchAriaLabel': 'Tìm kiếm',
  'modals.missionQuickViewModal.description': 'Tổng quan nhanh nhiệm vụ. Mở trang nhiệm vụ để xem chi tiết.',
  'modals.missionQuickViewModal.close': 'Đóng',
  'modals.missionQuickViewModal.openDetails': 'Mở chi tiết',
  'modals.missionQuickViewModal.openDetailsAria': 'Mở chi tiết nhiệm vụ',
  'modals.leadDetailModal.close': 'Đóng',
  'modals.leadDetailModal.whoIsThis': 'Đây là ai?',
  'modals.leadDetailModal.whatDoTheyNeed': 'Họ cần gì?',
  'modals.leadDetailModal.whatDoISay': 'Tôi nên nói gì?',
  'modals.leadDetailModal.moreProducts': 'Thêm sản phẩm',
  'modals.regionDetailsModal.description': 'Tổng quan chi tiết nhiệm vụ. Chỉ xem.',
  'modals.regionDetailsModal.edit': 'Chỉnh sửa',
  'modals.regionDetailsModal.close': 'Đóng',
  'modals.editRegionModal.close': 'Đóng',
  'modals.editRegionModal.description': 'Chỉnh sửa giờ và ghi chú cho nhiệm vụ. Trạng thái chỉ xem.',
  'modals.editRegionModal.statusReadonlySrOnly': 'Trạng thái chỉ xem.',
  'modals.splitAssignmentDialog.actionLabel': 'Chọn thao tác',
  'modals.splitAssignmentDialog.confirmButton': 'Xác nhận',
  'modals.addAppointmentModal.companyAriaLabel': 'Chọn hoặc nhập công ty / lead',
  'modals.addAppointmentModal.commitmentConfirmed': 'Đã xác nhận',
  'modals.rejectLead.title': 'Từ chối lead',
  'modals.rejectLead.closeAria': 'Đóng hộp thoại',
  'modals.rejectLead.description': 'Chọn ít nhất một lý do từ chối.',
  'modals.rejectLead.reasonsLabel': 'Lý do từ chối',
  'modals.rejectLead.reasonsError': 'Vui lòng chọn ít nhất một lý do.',
  'modals.rejectLead.otherReasonLabel': 'Lý do khác',
  'modals.rejectLead.otherReasonPlaceholder': 'Vui lòng mô tả lý do...',
  'modals.rejectLead.otherReasonAria': 'Lý do từ chối khác',
  'modals.rejectLead.otherReasonError': 'Vui lòng nhập lý do.',
  'modals.rejectLead.cancel': 'Hủy',
  'modals.rejectLead.confirm': 'Từ chối ({count})',
  'modals.rejectLead.reason.outOfBusiness': 'Ngừng kinh doanh',
  'modals.rejectLead.reason.temporarilyClosed': 'Tạm đóng cửa',
  'modals.rejectLead.reason.knownAndUnsuitable': 'Đã biết và không phù hợp',
  'modals.rejectLead.reason.noInterest': 'Không quan tâm',
  'modals.rejectLead.reason.wrongContact': 'Sai người liên hệ',
  'modals.rejectLead.reason.other': 'Khác',

  // Learning (SS-145)
  'common.active': 'Hoạt động',
  'common.archived': 'Đã lưu trữ',
  'common.planned': 'Đã lên kế hoạch',
  'missionControl.totalLeads': 'Tổng số khách hàng tiềm năng',
  'missionControl.completedLeads': 'Khách hàng tiềm năng đã hoàn thành',
  'common.archive': 'Lưu trữ',

  'survey.contact.name': 'Tên',
  'survey.contact.namePlaceholder': 'Nhập tên',
  'survey.contact.function': 'Chức vụ / Vai trò',
  'survey.contact.functionPlaceholder': 'Nhập chức vụ',
  'survey.contact.email': 'Email',
  'survey.contact.emailPlaceholder': 'Nhập địa chỉ email',
  'survey.contact.phone': 'Điện thoại',
  'survey.contact.phonePlaceholder': 'Nhập số điện thoại',
  'survey.contact.isDecisionMaker': 'Là người quyết định?',
}
